import ERP from "../ERP.mjs";

export default {

    async getNotaFiscalByPlugNotasId(notaFiscalValores = {}){

        let notaFiscal;

        try{

            notaFiscal = await ERP.getNotaFiscalByPlugNotasId({
                plugNotasId: notaFiscalValores.plugNotasId
            });
            if(notaFiscal.status != 200){
                throw notaFiscal;
            }

            // Cria a BlobURL
            const blobUrl = URL.createObjectURL(notaFiscal.data);
            
            // Cria o Link
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${notaFiscalValores.nomeArquivo}.pdf`;
            link.click();

            // Abrir em nova aba/flutuante
            window.open(blobUrl, '_blank');

            console.log(notaFiscal);

        }catch(e){

            console.log(e);
            return notaFiscal;

        }

        return notaFiscal;

    },

}